// extracted by mini-css-extract-plugin
export default {"title":"PublishPaper_title__i-PbA","publish-details":"PublishPaper_publish-details__rRxJZ","view-btn":"PublishPaper_view-btn__dAhSC","creator":"PublishPaper_creator__MNy8n"};